import { EditableGridActionTypes } from "./EditableGridActions";
export const EditableGridReducer = (state, action) => {
    switch (action.type) {
        case EditableGridActionTypes.UPDATE_EDIT_ROW_DATA:
            return {
                ...state,
                rowDataOnEdit: action.rowData
            };
        case EditableGridActionTypes.UPDATE_ADD_NEW_ROW_DATA:
            return {
                ...state,
                addNewRowData: action.rowData
            };
        case EditableGridActionTypes.SET_ROW_TO_EDIT:
            return {
                ...state,
                rowIndexOnEdit: action.payload.rowIndex,
                rowDataOnEdit: action.payload.rowData
            };
        case EditableGridActionTypes.INCREMENT_INDEX_ON_EDIT:
            return {
                ...state,
                rowIndexOnEdit: state.rowIndexOnEdit != undefined ? state.rowIndexOnEdit + 1 : undefined
            };
        case EditableGridActionTypes.DECREMENT_INDEX_ON_EDIT:
            return {
                ...state,
                rowIndexOnEdit: state.rowIndexOnEdit ? state.rowIndexOnEdit - 1 : undefined
            };
        case EditableGridActionTypes.RESET_INDEX_ON_EDIT:
            return {
                ...state,
                rowIndexOnEdit: undefined,
                rowDataOnEdit: undefined
            };
        default:
            return state;
    }
};
